<div class="messages-page">
  <div class="header">
    <h1>{{ 'message.title' | translate }}</h1>
    <div class="header-content">
      <div class="actions">
        <ecab-button class="btn-back" variant="text" icon="arrow_back" [label]="'common.actions.back' | translate" (clicked)="router.navigateByUrl('/')"></ecab-button>
        <ecab-button class="btn-primary" variant="primary" icon="add" [label]="'message.actions.new' | translate" (clicked)="createNewMessage()"></ecab-button>
      </div>
    </div>
  </div>

  <section class="filter-workspace" data-testid="filter-workspace">
    <div class="filter-top-row">
      <ecab-input
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
        [placeholder]="'common.search' | translate"
        icon="search"
        iconPosition="prefix"
        class="search-input">
      </ecab-input>
    </div>
    <mat-expansion-panel
      class="workspace-panel filter-panel"
      [expanded]="advancedFiltersSectionExpanded"
      (opened)="setSectionExpanded('advanced', true)"
      (closed)="setSectionExpanded('advanced', false)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="material-icons">tune</span>
          {{ 'filter.workspace.advanced' | translate }}
        </mat-panel-title>
        @if (!advancedFiltersSectionExpanded) {
          <mat-panel-description>{{ advancedFiltersSectionSummary }}</mat-panel-description>
        }
      </mat-expansion-panel-header>
      <div class="filter-content workspace-panel-content">
        <div class="filter-row">
          <ecab-select class="filter-field"
                      [(ngModel)]="buildingMode"
                      [label]="'filter.buildingMode' | translate"
                      [options]="[
                        {value: FilterMode.ALL, label: 'filter.mode.all' | translate},
                        {value: FilterMode.EMPTY, label: 'filter.mode.empty' | translate},
                        {value: FilterMode.SELECTED_VALUES, label: 'filter.mode.selectedValues' | translate}
                      ]"
                      (selectionChange)="onBuildingModeChange()">
          </ecab-select>
          <ecab-input class="filter-field"
                      [(ngModel)]="buildingIdFilter"
                      [label]="'filter.buildingId' | translate"
                      [placeholder]="'filter.multiValueHint' | translate"
                      [disabled]="buildingMode !== FilterMode.SELECTED_VALUES">
            @if (buildingIdFilter) {
              <button matSuffix mat-icon-button type="button" [attr.aria-label]="'common.actions.clear' | translate" (click)="buildingIdFilter=''">
                <mat-icon>close</mat-icon>
              </button>
            }
          </ecab-input>
          <ecab-input class="filter-field"
                      [(ngModel)]="caseIdFilter"
                      [label]="'filter.caseId' | translate"
                      [placeholder]="'filter.caseId' | translate">
            @if (caseIdFilter) {
              <button matSuffix mat-icon-button type="button" [attr.aria-label]="'common.actions.clear' | translate" (click)="caseIdFilter=''">
                <mat-icon>close</mat-icon>
              </button>
            }
          </ecab-input>
          <ecab-select class="filter-field"
                      [(ngModel)]="townGroupIds"
                      [multiple]="true"
                      [label]="'filter.townGroup' | translate"
                      [placeholder]="'filter.townGroup' | translate"
                      [options]="townGroupOptions">
            @if (townGroupIds.length > 0) {
              <button matSuffix mat-icon-button type="button" [attr.aria-label]="'common.actions.clear' | translate" (click)="townGroupIds=[]; $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </ecab-select>
          <ecab-select class="filter-field"
                      [(ngModel)]="personMode"
                      [label]="'filter.personMode' | translate"
                      [options]="[
                        {value: FilterMode.ALL, label: 'filter.mode.all' | translate},
                        {value: FilterMode.EMPTY, label: 'filter.mode.empty' | translate},
                        {value: FilterMode.SELECTED_VALUES, label: 'filter.mode.selectedValues' | translate}
                      ]"
                      (selectionChange)="onPersonModeChange()">
          </ecab-select>
          <ecab-input class="filter-field"
                      [(ngModel)]="personIdFilter"
                      [label]="'filter.personId' | translate"
                      [placeholder]="'filter.multiValueHint' | translate"
                      [disabled]="personMode !== FilterMode.SELECTED_VALUES">
            @if (personIdFilter) {
              <button matSuffix mat-icon-button type="button" [attr.aria-label]="'common.actions.clear' | translate" (click)="personIdFilter=''">
                <mat-icon>close</mat-icon>
              </button>
            }
          </ecab-input>
          <ecab-select class="filter-field"
                      [(ngModel)]="caseTypeFilter"
                      [label]="'filter.category' | translate"
                      [placeholder]="'filter.category' | translate"
                      [options]="[
                        {value: undefined, label: 'caseType.all' | translate},
                        {value: CaseType.NONE, label: 'caseType.none' | translate},
                        {value: CaseType.DAMAGE, label: 'caseType.damage' | translate},
                        {value: CaseType.ESTIMATION, label: 'caseType.estimation' | translate},
                        {value: CaseType.SUBSIDY, label: 'caseType.subsidy' | translate}
                      ]">
            @if (caseTypeFilter !== undefined) {
              <button matSuffix mat-icon-button type="button" [attr.aria-label]="'common.actions.clear' | translate" (click)="caseTypeFilter=undefined; $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </ecab-select>
          <ecab-select class="filter-field"
                      [(ngModel)]="questionTypeFilter"
                      [label]="'filter.questionType' | translate"
                      [options]="getQuestionTypeOptions()">
            @if (questionTypeFilter) {
              <button matSuffix mat-icon-button type="button" [attr.aria-label]="'common.actions.clear' | translate" (click)="questionTypeFilter=undefined; $event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </ecab-select>
        </div>
        <div class="filter-actions">
          <ecab-button variant="primary" icon="check" [label]="'filter.apply' | translate" (clicked)="applyFilters()"></ecab-button>
          <ecab-button variant="secondary" icon="clear" [label]="'filter.clear' | translate" (clicked)="clearFilters()"></ecab-button>
        </div>
      </div>
    </mat-expansion-panel>
  </section>

  <div class="messages-list">
    @for (msg of messages; track msg.id) {
    <div class="message-card"
         (click)="openMessage(msg)">
      <div class="message-avatar"
           [style.background-color]="getAvatarColor(msg)">
        {{ getInitials(msg) }}
      </div>
      <div class="message-info">
        <div class="message-top">
          <span class="contact-name">{{ getContactDisplay(msg) }}</span>
          <span class="message-date">{{ msg.date | date:'dd.MM.yyyy HH:mm' }}</span>
        </div>
        <div class="message-middle">
          <span class="message-subject">{{ msg.subject }}</span>
          @if (msg.status) {
          <span class="message-status"
                [class]="msg.status.toLowerCase()">{{ 'message.status.' + (msg.status |
            lowercase) | translate }}</span>
          }
        </div>
        <div class="message-bottom">
          <p class="message-preview">{{ msg.content | markdownExcerpt:160 }}</p>
          <div class="context-tags">
            @if (msg.personId) {
            <span class="tag tag-person">
              <span class="material-icons">person</span>
              {{ msg.personId }}
            </span>
            }
            @if (msg.buildingAddress) {
            <span class="tag tag-building">
              <span class="material-icons">home</span>
              {{ msg.buildingAddress }}
            </span>
            }
            @if (msg.caseTitle) {
            <span class="tag tag-case">
              <span class="material-icons">folder</span>
              {{ msg.caseTitle }}
            </span>
            }
            @if (msg['questionType']) {
            <span class="tag tag-question-type">
              <span class="material-icons">category</span>
              {{ ('message.questionType.' + msg['questionType'] )| translate }}
            </span>
            }
          </div>
        </div>
      </div>
    </div>
    } @empty {
    <div class="no-messages">
      <span class="material-icons">forum</span>
      <p>{{ 'message.list.empty' | translate }}</p>
    </div>
    }
  </div>

  <mat-paginator [length]="totalElements"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="[10, 20, 50]"
                 (page)="onPageChange($event)"
                 class="paginator">
  </mat-paginator>
</div>

<app-new-message-modal
  [open]="isCreateModalOpen"
  (closed)="closeCreateModal()"
  (created)="onMessageCreated()">
</app-new-message-modal>
